(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('provinceCountyDistrict', provinceCountyDistrict);

    function provinceCountyDistrict() {
        var directive = {
            templateUrl: '/app/common/province-county-district.html',
            scope: {
                input: '=',
                // selected : '=',
                isrequired: '=',
                // defaultval:'=',
                // minval: '<',
                // maxval: '<',
                // iszero: '@',
                // placeholder: '@',
                // label: '@',
                isdisabled: '=',
                // nullError: '=',
                // errorText: '@',
                // incrementRate: '<',
                // style: '@'
            },
            restrict: 'EA',
            controller: provinceCountyDistrictController,
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;

    }

    provinceCountyDistrictController.$inject = ['provinceListService', '$scope'];
    function provinceCountyDistrictController(provinceListService, $scope) {
        var vm = this;

        vm.selected = {};

        vm.selectCountry = (country) => {
            vm.input.geoIds.countryId = country.CountryId;
            vm.input.geoNames.countryName = country.CountryName;
            loadCities();
        }

        vm.selectCity = (city) => {
            vm.input.geoIds.cityId = city.CityId;
            vm.input.geoNames.cityName = city.CityName;
            loadCounties();
        }

        vm.selectCounty = (county) => {
            if (county) {
                vm.input.geoIds.countyId = county.CountyId;
                vm.input.geoNames.countyName = county.CountyName;
                loadDistricts();
            }
        }

        vm.selectDistrict = (district) => {
            if (district) {
                vm.input.geoIds.districtId = district.DistrictId;
                vm.input.geoNames.districtName = district.DistrictName;
            }
        }

        const loadCities = () => {
            provinceListService.getProvinces(vm.selected.country.CountryId).then(function (response) { vm.Cities = response.List; });
        }

        const loadCounties = () => {
            provinceListService.CountiesOfProvince(vm.selected.country.CountryId, vm.selected.city.CityId).then(function (response) { vm.Counties = response.List; });
        }

        const loadDistricts = function () {
            if (vm.selected.city && vm.selected.county) {
                provinceListService.NeighbourhoodsOfCounty(vm.selected.country.CountryId, vm.selected.city.CityId, vm.selected.county.CountyId).then(function (response) { vm.Districts = response.List; });
            }
        }

        vm.countryOptions = [
            {CountryName:'Türkiye', CountryId: 1},
            {CountryName:'İspanya', CountryId: 2},
            {CountryName:'Portekiz', CountryId: 3}
        ];

        const fillInputs = () => {
            if (vm.input.geoNames && vm.input.geoNames.countryName) {
                vm.selected.country = vm.countryOptions.find(c => c.CountryName === vm.input.geoNames.countryName);
                if (!vm.selected.country) return;
            } else {
                // Old records may carry city/county ids without a country name; they are Türkiye-era data.
                vm.selected.country = vm.countryOptions[0];
                vm.input.geoNames = vm.input.geoNames || {};
                vm.input.geoIds.countryId = vm.selected.country.CountryId;
                vm.input.geoNames.countryName = vm.selected.country.CountryName;
            }

            provinceListService.getProvinces(vm.selected.country.CountryId).then(citiesList => {
                vm.Cities = citiesList.List;
                vm.selected.city = citiesList.List.find(city => city.CityId === vm.input.geoIds.cityId);
                if (!vm.selected.city) return;
                provinceListService.CountiesOfProvince(vm.selected.country.CountryId, vm.selected.city.CityId).then(response => {
                    vm.Counties = response.List;
                    vm.selected.county = response.List.find(county => county.CountyId === vm.input.geoIds.countyId);
                    if (!vm.selected.county) return;
                    provinceListService.NeighbourhoodsOfCounty(vm.selected.country.CountryId, vm.selected.city.CityId, vm.selected.county.CountyId).then(res => {
                        vm.Districts = res.List;
                        vm.selected.district = res.List.find(district => district.DistrictId === vm.input.geoIds.districtId);
                    });
                });
            });
        }

        // county/district may be missing on old records; show whatever location data exists.
        const unwatchInput = $scope.$watch(() => vm.input && vm.input.geoIds, geoIds => {
            if (geoIds && geoIds.cityId) {
                unwatchInput();
                fillInputs();
            }
        });
    }
})();